import React from 'react';
import PropTypes from 'prop-types';
import { categories as CAT } from 'utils/categories';
import { getMacroName, getMicroName } from 'utils/getCategoryData';

const CategoryIcon = ({ macro, microCat, className = '', ...props }) => {
  const macroId = Number(macro);
  const microId = microCat != null ? Number(microCat) : null;

  const macroCategory = CAT.find((c) => c.id === macroId);
  if (!macroCategory) return null;

  const subs =
    macroCategory?.micro ||
    macroCategory?.microCategories ||
    macroCategory?.children ||
    [];

  const microCategory =
    microId != null ? subs.find((m) => m.id === microId) : null;

  const folder = macroCategory.icon || macroCategory.slug || `macro_${macroId}`;
  const fileForMacro = macroCategory.icon || folder;
  const fileForMicro = microCategory?.icon;

  const reqSvg = (folderName, fileName) => {
    // eslint-disable-next-line import/no-dynamic-require, global-require
    return require(
      `../../assets/icons/categories/${folderName}/${fileName}.svg`
    );
  };

  let src;
  try {
    const mod = fileForMicro
      ? reqSvg(folder, fileForMicro)
      : reqSvg(folder, fileForMacro);
    src = mod?.default || mod;
  } catch (err1) {
    try {
      const mod = reqSvg(folder, fileForMacro);
      src = mod?.default || mod;
    } catch (err2) {
      console.error('CategoryIcon error:', {
        folder,
        fileForMacro,
        fileForMicro,
        err1,
        err2,
      });
      return null; // final fallback: render nothing instead of crashing
    }
  }

  const alt = microCategory
    ? `${getMacroName(macroId)} - ${getMicroName(microId)} icon`
    : `${getMacroName(macroId)} icon`;

  return <img src={src} className={`icon ${className}`} alt={alt} {...props} />;
};

CategoryIcon.propTypes = {
  className: PropTypes.string,
};

export default CategoryIcon;
